module.exports = __webpack_public_path__ + "static/media/cotton_icon.7d50ccae.svg";